import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ResolutionService } from '../resolution.service';
import { Resolution } from '../resolution';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover, getEllipsisOptionValue } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import { buttonStatus } from '../../../shared/constants/button-class';
import { ellipsisOptions } from '../../../shared/constants/ellipsis-options';
import { FormGroup } from '@angular/forms';
import { FormField } from '../../../shared/form-field/form-field';
import { ContractFormFieldService } from '../../../services/contract-form-field.service';
import { FormCanDeactivate } from '../../../shared/form-field/form-can-deactivate';

@Component({
  standalone: false,
  selector: 'symptom-one',
  templateUrl: 'symptom-one.template.html',
  styleUrls: ['symptom-one.scss'],
  providers: [ResolutionService, ContractFormFieldService],
})
export class SymptomOneComponent extends FormCanDeactivate implements OnInit {
  formModalInfo: FormField<any>[] = [];
  searchResults: Resolution[];
  cols: any[];
  selectedItem: any;
  btnStatus: any = buttonStatus;
  options: any[] = ellipsisOptions;
  selectedEllipsisItem: any;
  displayAdd: boolean;
  displayUpdate: boolean;

  constructor(
    private search: ResolutionService,
    private cdr: ChangeDetectorRef,
    private contractService: ContractFormFieldService,
  ) {
    super();
    this.displayAdd = false;
    this.displayUpdate = false;
  }

  ngOnInit() {
    this.searchResults = this.search.getSymptomOnes();
    this.cols = [{ field: 'symptom' }];
    this.options = [
      { label: 'Add', value: 'add' },
      { label: 'Update', value: 'update' },
    ];
    this.contractService
      .getFormModalFields()
      .subscribe((formModalInfo) => (this.formModalInfo = formModalInfo));
  }
  selectItem(event, item, Popover: Popover) {
    this.selectedItem = item;
    toggleEllipsisPopover(event, Popover);
  }
  handleOpen(e) {
    if (getEllipsisOptionValue(e) === 'add') {
      this.displayAdd = true;
    } else {
      this.displayUpdate = true;
    }
    this.cdr.detectChanges();
  }
  onYes() {
    this.displayAdd = false;
    this.displayUpdate = false;
    this.cdr.detectChanges();
  }
}
